import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import BASE_URL from "../config"; // ✅ Import BASE_URL

const ClientDetail = () => {
    const [selectedClient, setSelectedClient] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    const getClientIdFromURL = () => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get("id") ? parseInt(searchParams.get("id")) : null;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    };

    useEffect(() => {
        const clientId = getClientIdFromURL();
        if (!clientId) {
            setSelectedClient(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        const token = localStorage.getItem("token"); // Get token from localStorage
        axios.get(`${BASE_URL}api/clients/find-one/${clientId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => {
                setSelectedClient(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching client detail:", error);
                setSelectedClient(null);
                setLoading(false);
            });
    }, [location.search]);

    if (loading) {
        return (
            <div className="text-center mt-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p>Loading client details...</p>
            </div>
        );
    }

    if (!selectedClient) {
        return <div className="text-center mt-5">No client data found.</div>;
    }

    return (
        <div className="clients mt-4 mx-3">
            <h2 className="mb-3">Client Details</h2>

            {/* Add Payment button with correct client_id */}
            <a href={`/add-payment?id=${selectedClient.id}`} className="btn btn-primary mb-3">Add Payment</a>

            <div className="card mb-3">
                <div className="card-header bg-dark text-white">Client Info</div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6"><strong>Name:</strong> {selectedClient.name}</div>
                        <div className="col-md-6"><strong>Phone:</strong> {selectedClient.phone}</div>
                        <div className="col-md-6"><strong>Email:</strong> {selectedClient.email}</div>
                        <div className="col-md-6"><strong>Country:</strong> {selectedClient.country || "N/A"}</div>
                        <div className="col-md-6"><strong>Website:</strong> {selectedClient.website || "N/A"}</div>
                    </div>
                </div>
            </div>

            <div className="card mb-3">
                <div className="card-header bg-dark text-white">Payment Info</div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6"><strong>Payment Type:</strong> {selectedClient.payment_type}</div>
                        <div className="col-md-6"><strong>Payment Mode:</strong> {selectedClient.payment_mode}</div>
                        {/* <div className="col-md-6">
                            <strong>Last Payment Date:</strong>{" "}
                            {formatDate(selectedClient.last_payment_date || selectedClient.payments?.[0]?.last_payment_date)}
                        </div>
                        <div className="col-md-6">
                            <strong>Next Due Date:</strong>{" "}
                            {formatDate(selectedClient.next_due_date || selectedClient.payments?.[0]?.next_due_date)}
                        </div> */}
                    </div>
                </div>
            </div>

            <div className="card mb-3">
                <div className="card-header bg-dark text-white"><strong>Asset Type:</strong> {selectedClient.asset_type}</div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="card text-white bg-success mb-3">
                                <div className="card-header">Domain Info</div>
                                <div className="card-body">
                                    <ul className="client-list">
                                        {selectedClient.domain_info ? <li>{selectedClient.domain_info}</li> : <li>N/A</li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card text-white bg-danger mb-3">
                                <div className="card-header">Server Info</div>
                                <div className="card-body">
                                    <ul className="client-list">
                                        {selectedClient.server_info ? <li>{selectedClient.server_info}</li> : <li>N/A</li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card text-white bg-warning mb-3">
                                <div className="card-header">Email Info</div>
                                <div className="card-body">
                                    <ul className="client-list">
                                        {selectedClient.email_info ? <li>{selectedClient.email_info}</li> : <li>N/A</li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            
            <a href="/clients" className="btn btn-secondary ms-2">Cancel</a>
        </div>
    );
};

export default ClientDetail;
